import { Link } from 'react-router-dom'
import './auth.css'

export default function LandingPage() {
  return (
    <div className="auth-page">
      <div className="auth-card auth-card--landing">
        <h1 className="auth-title">wortelogy</h1>
        <p className="auth-subtitle">Point of sale for your business</p>
        <div className="auth-actions">
          <Link to="/login" className="auth-btn auth-btn--secondary">
            Sign in
          </Link>
          <Link to="/register" className="auth-btn auth-btn--primary">
            Get started
          </Link>
        </div>
      </div>
    </div>
  )
}
